import type { QualityMetrics } from "@zworks/console-contracts";

/** One figure on the panel. A null value shows the reason it is empty, never a zero. */
export interface QualityMetricTile {
  label: string;
  value: string;
  detail: string;
}

/** Formats micro-dollars as dollars, keeping small amounts visible. */
export function formatMicrousd(microusd: number): string {
  return `$${(microusd / 1_000_000).toLocaleString("en-GB", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 6,
  })}`;
}

/** Builds the panel figures from the summary, in the order owners read them. */
export function qualityMetricTiles(metrics: QualityMetrics): QualityMetricTile[] {
  const { requirements, flake, heals, triage, cost } = metrics;
  const reversed =
    heals.reversedByPerson === null
      ? "Reversed by a person: not recorded yet"
      : `Reversed by a person: ${heals.reversedByPerson}`;
  const approved = cost.acceptedTests === 1 ? "approved test" : "approved tests";
  return [
    {
      label: "Requirements with a passing approved test",
      value:
        requirements.sharePercent === null
          ? "No requirements yet"
          : `${requirements.sharePercent}%`,
      detail: `${requirements.withPassingApprovedTest} of ${requirements.total} requirements`,
    },
    {
      label: "Flake rate",
      value: flake.ratePercent === null ? "No results yet" : `${flake.ratePercent}%`,
      detail: `${flake.flakyResults} of ${flake.executedResults} executed results`,
    },
    {
      label: "Healed results",
      value: `${heals.healed}`,
      detail: reversed,
    },
    {
      label: "Time to triage verdict",
      value: triage.secondsToVerdict === null ? "Not recorded yet" : `${triage.secondsToVerdict} s`,
      detail: "The runtime stores no triage time yet",
    },
    {
      label: "Eval spend per approved test",
      value:
        cost.perAcceptedTestMicrousd === null
          ? "No approved tests yet"
          : formatMicrousd(cost.perAcceptedTestMicrousd),
      detail: `${formatMicrousd(cost.evalSpendMicrousd)} eval spend across ${cost.acceptedTests} ${approved}, not counting agent authoring`,
    },
  ];
}
